export interface ICreditorsFilterRequest {
    filteredByValue: string;
}

export const emptyFilterRequest: ICreditorsFilterRequest = {
    filteredByValue: '',
}